import { Injectable } from '@angular/core';
import { ConfigService } from '@aiwyn/config';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {

  constructor(private configService: ConfigService) { }

  /**
   * This method is called from pay() in the invoice component,
   * it is responsible for redirecting after successful payment has been made.
   */
  redirectAfterPay(): void {
    setTimeout(
      () => location.href = this.configService.redirectUrl,
      this.configService.redirectDelay,
    );
  }
}
